import { Component, OnInit } from '@angular/core';
import { GamesGroupService, GroupType, TriviaGroupSummary } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-trivia-play',
  templateUrl: 'trivia-play.component.html',
  styleUrl: './trivia-page.component.scss',
})
export class TriviaPlayComponent implements OnInit {
  gamesGroup$: Observable<TriviaGroupSummary[]>;
  groupType = GroupType.Trivia;

  constructor(private gamesGroupService: GamesGroupService) {}
  ngOnInit(): void {
    this.gamesGroup$ = this.gamesGroupService.fetchTriviaGroups();
  }
}

@Component({
  selector: 'fgb-trivia-page',
  templateUrl: './trivia-page.component.html',
  styleUrl: './trivia-page.component.scss',
})
export class TriviaPageComponent implements OnInit {
  ngOnInit(): void {}
}
